import React from 'react';

export const TableSkeleton = ({ rows = 5, columns = 4 }) => {
  return (
    <div className="w-full overflow-hidden rounded-xl border border-slate-100 dark:border-slate-700/60 bg-white dark:bg-slate-800/60">
      <table className="min-w-full divide-y divide-slate-100 dark:divide-slate-700/60">
        <thead className="bg-slate-50 dark:bg-slate-800/40">
          <tr>
            {Array.from({ length: columns }).map((_, i) => (
              <th key={i} className="px-6 py-3">
                <div className="h-4 w-20 animate-pulse rounded bg-slate-200 dark:bg-slate-600" />
              </th>
            ))}
          </tr>
        </thead>

        <tbody className="divide-y divide-slate-100 dark:divide-slate-700/60">
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <tr key={rowIndex}>
              {Array.from({ length: columns }).map((_, colIndex) => (
                <td key={colIndex} className="whitespace-nowrap px-6 py-4">
                  <div className="h-4 w-full animate-pulse rounded bg-slate-200 dark:bg-slate-600" />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableSkeleton;
